import React from "react";
import { useNavigate } from "react-router-dom";
import { useFormik } from "formik";
import { toast } from "react-toastify";
import {
  Box,
  Button,
  Container,
  Paper,
  Stack,
  TextField,
  Typography,
} from "@mui/material";

import { OrgAdminApi } from "../../api/OrgAdminApi";
import FormContent from "../../components/organization/orgGrpFormSchema.jsx";
import { isError, getErrorMsg, validateForm } from "../../helper/FormHelper.jsx";

const LIST_PATH = "/user/grps";

export default function UserGrpCreatePage() {
  const navigate = useNavigate();
  const formik = useFormik(FormContent.FormikInstance);

  const handleCreate = async () => {
    if (await validateForm(formik)) return;

    const payload = {
      grp_code: formik.values.grp_code.trim(),
      name_zh: formik.values.name_zh.trim(),
      name_en: (formik.values.name_en || "").trim(),
      display_pos: Number(formik.values.display_pos),
    };

    OrgAdminApi.createGrpCallback(payload, (isSuccess, msg) => {
      if (!isSuccess) {
        toast.error(typeof msg === "string" && msg ? msg : "新增失敗");
        return;
      }

      toast.success("新增成功");
      navigate(LIST_PATH);
    });
  };

  return (
    <Container maxWidth="lg">
      <Typography variant="h4" sx={{ mt: 2, mb: 3 }}>
        新增社
      </Typography>

      <Paper sx={{ px: 3, py: 4 }} elevation={3}>
        <Stack spacing={3} component="form" onSubmit={(event) => event.preventDefault()}>
          {FormContent.FormControl.map((item) => {
            const field = item.props;
            return (
              <TextField
                key={field.id}
                {...field}
                name={field.id}
                value={formik.values[field.id] ?? ""}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                error={isError(formik, field.id)}
                helperText={getErrorMsg(formik, field.id)}
                fullWidth
              />
            );
          })}
          <Stack direction="row" spacing={2}>
            <Button variant="contained" onClick={handleCreate} disabled={!formik.isValid}>
              新增
            </Button>
            <Box sx={{ flexGrow: 1 }} />
            <Button variant="text" onClick={() => navigate(LIST_PATH)}>
              返回列表
            </Button>
          </Stack>
        </Stack>
      </Paper>
    </Container>
  );
}
